import axios from "axios";
import {Inject, injectable} from 'inversify-props';

@injectable()
export default class HttpClient {
  constructor(){

  }

  private apiUrlBuilder(path: string) {
    let indieApiUrl = process.env.VUE_APP_INDIE_API;
    return `${indieApiUrl}${path}`;
  }

  private tpUrlBuilder(path: string) {
    let tpApiUrl = process.env.VUE_APP_TRIPPLANNER_API;
    return `${tpApiUrl}${path}`;
  }

  public async get(path: string): Promise<any> {
    let url = this.apiUrlBuilder(path);
    return await axios.get(url, {withCredentials: true});
  }

  public async post(path: string, body: any, multipart:boolean = false): Promise<any> {
    let url = this.apiUrlBuilder(path);
    let config = {withCredentials: true, headers: {}}
    if(multipart){
      config.headers = {
        'Content-Type': 'multipart/form-data'
      }
    }
    return await axios.post(url, body, config);
  }

  public async postTp(path: string, body: any): Promise<any> {
    let url = this.tpUrlBuilder(path);
    let axiosConfig = {};
    if(process.env.VUE_APP_TRIPPLANNER_API_USER && process.env.VUE_APP_TRIPPLANNER_API_PASSWORD){
      axiosConfig = {
        auth: {
          username: process.env.VUE_APP_TRIPPLANNER_API_USER,
          password: process.env.VUE_APP_TRIPPLANNER_API_PASSWORD
        },
        withCredentials: true,
        headers: {
          "Content-Type": "application/json"
        }
      };
    }
    const client = axios.create(axiosConfig);
    let response = await client.post(url, body);
    return response;
  }
}
